import { mapCollection, sortByString } from '../../utils/collection.utils';
import { Privilege } from '../privilege';

export class PrivilegeBuilder {
  static fromJson(json: any) {
    return (json)
      ? new Privilege(
        json.hash,
        json.name,
        json.defaultPrivilege
      )
      : null;
  }

  static fromList(list) {
    return sortByString('name', mapCollection(PrivilegeBuilder.fromJson, list));  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/privilege.builder.ts